// src/components/Header.js
import React, { useEffect, useState } from "react";
import socialLogos from "../assets/social-logos.png";
const titles = ["Victor here", "Happy to meet you!"];

function Header({ showTitles, toggleTitles, isDarkMode, toggleTheme, totalLikes, sortById, toggleSortById }) {
  const [titleIndex, setTitleIndex] = useState(0);

  const iconBaseStyle = {
    width: "28px",
    height: "31px",
    backgroundImage: `url(${socialLogos})`,
    filter: "grayscale(100%)",
    backgroundSize: "300% 100%",
    backgroundRepeat: "no-repeat",
    display: "inline-block",
    cursor: "pointer",
    transition: "transform 0.2s",
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTitleIndex((prev) => (prev + 1) % titles.length);
    }, 2000); // change every 4 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <header
      className="header"
      style={{
        position: "sticky",
        top: 0,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        zIndex: 1000,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.1rem 1rem",
        borderBottom: "1px solid #ddd",
      }}
    >
      <div
        className="header-title"
        style={{
          fontSize: "1.8rem",
          fontWeight: "bold",
          background: "linear-gradient(90deg, purple, blue)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          color: "transparent",
          fontFamily: "Bebas Neue",
          flex: "1 1 auto",
          minWidth: 0,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "transform 0.6s ease-in-out",
          transform: "rotateX(360deg)",
          animation: "flip 0.8s ease-in-out",
          letterSpacing: "0px", // 👈 add this line
        }}
        key={titles[titleIndex]} // triggers re-animation on change
      >
        {titles[titleIndex]}
      </div>


      {/* RIGHT: Icons and Toggles */}
      {/* RIGHT: Icons and Toggles */}
      <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
        {/* YouTube icon */}
        <a
          href="https://www.youtube.com/@therealvictorursu"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
          style={{
            ...iconBaseStyle,
            backgroundPosition: "100% 0%",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />

        {/* Likes + Order Toggle stack */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.3rem" }}>
          <div
            style={{
              fontSize: "0.65rem",
              color: "#e74c3c",
              fontWeight: "bold",
            }}
          >
            ❤️ {totalLikes}
          </div>

          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={sortById}
              onChange={toggleSortById}
              style={{ display: "none" }}
            />
            <span
              style={{
                width: "40px",
                height: "20px",
                backgroundColor: sortById ? "#4caf50" : "#ccc",
                borderRadius: "20px",
                position: "relative",
                transition: "background-color 0.2s",
              }}
            >
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: sortById ? "22px" : "2px",
            width: "16px",
            height: "16px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            transition: "left 0.2s",
          }}
        />
      </span>
          </label>
        </div>

        {/* Info + Theme Toggles stack */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem" }}>
          {/* Info toggle */}
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={showTitles}
              onChange={toggleTitles}
              style={{ display: "none" }}
            />
            <span
              style={{
                width: "40px",
                height: "20px",
                backgroundColor: showTitles ? "#4caf50" : "#ccc",
                borderRadius: "20px",
                position: "relative",
                transition: "background-color 0.2s",
              }}
            >
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: showTitles ? "22px" : "2px",
            width: "16px",
            height: "16px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            transition: "left 0.2s",
          }}
        />
      </span>
          </label>

          {/* Theme toggle */}
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={isDarkMode}
              onChange={toggleTheme}
              style={{ display: "none" }}
            />
            <span
              style={{
                width: "40px",
                height: "20px",
                backgroundColor: isDarkMode ? "#4caf50" : "#ccc",
                borderRadius: "20px",
                position: "relative",
                transition: "background-color 0.2s",
              }}
            >
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: isDarkMode ? "22px" : "2px",
            width: "16px",
            height: "16px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            transition: "left 0.2s",
          }}
        />
      </span>
          </label>
        </div>
      </div>

    </header>
  );

}

export default Header;
